// extracted by mini-css-extract-plugin
export default {"content":"Content_content__TNP+D","container":"Content_container__2yfx3","titleDelivery":"Content_titleDelivery__xxuau"};